<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showRecommendation") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #091647">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- Start:: User Name Input -->
          <base-input
            type="text"
            col="12"
            :placeholder="$t('SIDENAV.Clients.name')"
            v-model="data.user.name"
            disabled
          />
          <!-- End:: User Name Input -->

          <!-- Start:: Recommendations Groups -->
          <div class="col-12">
            <h6 class="recommendation-section-title">
              {{ $t("PLACEHOLDERS.recommendations") }}
            </h6>

            <div
              v-if="!displayRecommendations.length"
              class="recommendation-empty"
            >
              {{ $t("TABLES.noData") }}
            </div>

            <div
              class="recommendation-group-card"
              v-for="(item, index) in displayRecommendations"
              :key="index"
            >
              <div class="recommendation-group-header">
                <span class="recommendation-list-label">
                  {{ $t("PLACEHOLDERS.recommendation_list") }}
                </span>
                <span class="recommendation-list-name">
                  {{ item.recommendations_list_name }}
                </span>
                <span class="recommendation-count">
                  {{ item.influencers.length }}
                </span>
              </div>

              <div class="recommendation-influencers">
                <span class="influencers-label">
                  {{ $t("PLACEHOLDERS.influencer_name") }}
                </span>
                <div class="influencers-chips">
                  <span
                    class="influencer-chip"
                    v-for="(name, i) in item.influencers"
                    :key="i"
                  >
                    {{ name }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- End:: Recommendations Groups -->

          <!-- Start:: Created At Input -->
          <base-input
            type="text"
            col="6"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            v-model="data.created_at"
            disabled
          />
          <!-- End:: Created At Input -->

          <!-- Start:: Total Recommended Input -->
          <base-input
            type="text"
            col="6"
            :placeholder="$t('PLACEHOLDERS.total_recommended')"
            v-model="data.total_recommended"
            disabled
          />
          <!-- End:: Total Recommended Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowRecommendation",

  data() {
    return {
      data: {
        user: {
          name: null,
        },
        created_at: null,
        total_recommended: null,
      },
      displayRecommendations: [],
    };
  },

  methods: {
    async showRecommendation() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `recommendations/${this.$route.params.id}`,
        });

        const recommendation = res.data.data.Recommendation;

        this.data.user = recommendation.user;
        this.data.created_at = recommendation.created_at;
        this.data.total_recommended = recommendation.total_recommended;

        this.displayRecommendations = [];
        const grouped = {};

        if (
          recommendation.recommendations &&
          recommendation.recommendations.length > 0
        ) {
          recommendation.recommendations.forEach((item) => {
            const list = item.recommendations_list;
            const listId = list?.id;
            if (!listId) return;

            if (!grouped[listId]) {
              grouped[listId] = {
                recommendations_list_name:
                  list.name_ar || list.name || list.name_en,
                influencers: [],
              };
            }

            if (item.influencer?.name || item.influencer?.nick_name) {
              grouped[listId].influencers.push(
                item.influencer.name || item.influencer.nick_name
              );
            }
          });

          this.displayRecommendations = Object.values(grouped);
        }
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },
  },

  created() {
    this.showRecommendation();
  },
};
</script>

<style scoped>
.recommendation-section-title {
  margin: 18px 0 14px;
  color: var(--theme_text_clr);
  font-weight: 600;
}

.recommendation-empty {
  padding: 16px;
  border-radius: 12px;
  background: var(--theme_inputs_clr);
  color: var(--theme_secondary_text_clr);
  margin-bottom: 16px;
}

.recommendation-group-card {
  background: var(--theme_inputs_clr);
  border-radius: 14px;
  padding: 16px 18px;
  margin-bottom: 14px;
  border: 1px solid rgba(9, 22, 71, 0.08);
}

.recommendation-group-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(9, 22, 71, 0.08);
}

.recommendation-list-label {
  color: var(--theme_secondary_text_clr);
  font-size: 13px;
}

.recommendation-list-name {
  color: var(--main_theme_clr);
  font-weight: 700;
  font-size: 16px;
}

.recommendation-count {
  margin-inline-start: auto;
  min-width: 28px;
  height: 28px;
  border-radius: 999px;
  background: var(--main_theme_clr);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  padding: 0 8px;
}

.recommendation-influencers {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.influencers-label {
  color: var(--theme_secondary_text_clr);
  font-size: 13px;
}

.influencers-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.influencer-chip {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(9, 22, 71, 0.08);
  color: var(--main_theme_clr);
  font-size: 13px;
  font-weight: 500;
}
</style>
